import { FC, useContext, useEffect, useState } from 'react';
import { getRandomImage } from '../services/config';
import SearchHotel from 'components/hotel/Search/SearchHotel';
import { cdnUrl } from '../constants/generic';
import { useLocation } from 'react-router-dom';
import SearchHistory from 'components/shared/SearchHistory';
import { MainContext } from 'contexts/MainContext';

const MainHPage: FC = ({ ...props }) => {
  const [bgImage, setBgImage] = useState<{ backgroundImage: string }>();
  const location = useLocation();
  const isEnigma = useContext(MainContext).isEnigma;
  useEffect(() => {
    if (isEnigma) return;
    (async () => {
      const response = await getRandomImage();
      setBgImage({ backgroundImage: `url(${cdnUrl + response?.imageUrl})` });
    })();
  }, [location.pathname]); // eslint-disable-line
  return (
    <div className="display-flex">
      <section className="main-page hotels" style={bgImage}>
        <div className="main-page-single position-relative">
          <SearchHotel loadingSearch={false} onClickStop={() => {}} />
          <SearchHistory hideArrow={true} />
        </div>
      </section>
    </div>
  );
};

export default MainHPage;
